import { AssignmentModel, CreateAssignmentAsServiceProviderModel, CreateAssignmentAsServiceProviderRequest, CreateServiceProviderAssignmentRequest } from '../../../../api-service/clients/auto-generated-clients';
import { DeepPartial } from '../../common/assignment/interfaces';

export function buildSpCreateAssignmentRequest(assignment: DeepPartial<AssignmentModel>, citizenCpr?: string, activityOfferId?: string): CreateAssignmentAsServiceProviderRequest {
  const assignmentPayload: CreateAssignmentAsServiceProviderModel = {
    citizenId: assignment.citizenId?.value ? { value: assignment.citizenId.value } : undefined,
    backgroundInformation: {
      name: assignment.backgroundInformation?.name ?? undefined,
      companyId: assignment.backgroundInformation?.companyId?.value ? { value: assignment.backgroundInformation.companyId.value } : undefined,
      serviceProviderUnitId: assignment.backgroundInformation?.serviceProviderUnitId?.value ? assignment.backgroundInformation?.serviceProviderUnitId?.value : undefined,
      responsibleUserId: assignment.backgroundInformation?.responsibleUserId,
      responsibleTeamId: assignment.backgroundInformation?.responsibleTeamId,
      citizenMedicalDiagnoses: assignment.backgroundInformation?.citizenMedicalDiagnoses,
      citizenMedicalDiagnosesRichText: assignment.backgroundInformation?.citizenMedicalDiagnosesRichText,
      specialInformationAboutCitizen: assignment.backgroundInformation?.specialInformationAboutCitizen,
      specialInformationAboutCitizenRichText: assignment.backgroundInformation?.specialInformationAboutCitizenRichText,
      hasGuardian: assignment.backgroundInformation?.hasGuardian,
      guardianType: assignment.backgroundInformation?.guardianType,
      guardianDetails: assignment.backgroundInformation?.guardianDetails,
      isRepresented: assignment.backgroundInformation?.isRepresented,
      representationType: assignment.backgroundInformation?.representationType,
      powersOfAttorney: assignment.backgroundInformation?.powersOfAttorney,
    },
    coordinationDetails: {
      descriptionOfOtherInterventions: assignment.coordinationDetails?.descriptionOfOtherInterventions,
      descriptionOfOtherInterventionsRichText: assignment.coordinationDetails?.descriptionOfOtherInterventionsRichText,
      agreementsBetweenCitizenAndRelatives: assignment.coordinationDetails?.agreementsBetweenCitizenAndRelatives,
    },
    assessmentInformation: {
      primaryAssessmentTopicId: assignment.assessmentInformation?.primaryAssessmentTopicId,
      additionalAssessmentTopicIds: assignment.assessmentInformation?.additionalAssessmentTopicIds,
      assessmentSummary: assignment.assessmentInformation?.assessmentSummary,
      assessmentSummaryRichText: assignment.assessmentInformation?.assessmentSummaryRichText,
      citizenSupportNeedsAssessment: assignment.assessmentInformation?.citizenSupportNeedsAssessment,
      citizenSupportNeedsAssessmentRichText: assignment.assessmentInformation?.citizenSupportNeedsAssessmentRichText,
      citizenPerspectiveInfo: assignment.assessmentInformation?.citizenPerspectiveInfo,
      citizenPerspectiveInfoRichText: assignment.assessmentInformation?.citizenPerspectiveInfoRichText,
      citizenAssessmentResourceInfo: assignment.assessmentInformation?.citizenAssessmentResourceInfo,
      citizenAssessmentResourceInfoRichText: assignment.assessmentInformation?.citizenAssessmentResourceInfoRichText,
      challengesAndNeedsInfo: assignment.assessmentInformation?.challengesAndNeedsInfo,
      challengesAndNeedsInfoRichText: assignment.assessmentInformation?.challengesAndNeedsInfoRichText,
      citizenFutureAspirationsInfo: assignment.assessmentInformation?.citizenFutureAspirationsInfo,
      citizenFutureAspirationsInfoRichText: assignment.assessmentInformation?.citizenFutureAspirationsInfoRichText,
      citizenAssessmentPurposeInfo: assignment.assessmentInformation?.citizenAssessmentPurposeInfo,
      citizenAssessmentPurposeInfoRichText: assignment.assessmentInformation?.citizenAssessmentPurposeInfoRichText,
    },
    commissionedIntervention: {
      grantTypeId: assignment.commissionedIntervention?.grantTypeId ?? 'undefined',
      socialOfferFFBId: assignment.commissionedIntervention?.socialOfferFFBId,
      benefitTypeIds: assignment.commissionedIntervention?.benefitTypeIds,
      reportingFrequency: assignment.commissionedIntervention?.reportingFrequency,
      daysBetweenMeasurements: assignment.commissionedIntervention?.daysBetweenMeasurements,
      followUpDate: assignment.commissionedIntervention?.followUpDate,
      agreementsBetweenAuthorityAndProvider: assignment.commissionedIntervention?.agreementsBetweenAuthorityAndProvider,
    },
  };

  const request: CreateAssignmentAsServiceProviderRequest = {
    assignment: assignmentPayload,
  };
  if (citizenCpr) {
    request.citizenCpr = citizenCpr;
  }
  if (activityOfferId) {
    request.activityOfferId = activityOfferId;
  }
  return request;
}

export function buildCreateServiceProviderAssignmentRequest(
  assignment: DeepPartial<AssignmentModel>,
  citizenId: string,
  activityId: string,
): CreateServiceProviderAssignmentRequest {
  const assignmentPayload: CreateAssignmentAsServiceProviderModel = {
    citizenId: assignment.citizenId?.value ? { value: assignment.citizenId.value } : undefined,
    backgroundInformation: {
      name: assignment.backgroundInformation?.name ?? undefined,
      companyId: assignment.backgroundInformation?.companyId?.value ? { value: assignment.backgroundInformation.companyId.value } : undefined,
      serviceProviderUnitId: assignment.backgroundInformation?.serviceProviderUnitId?.value ? assignment.backgroundInformation?.serviceProviderUnitId?.value : undefined,
      responsibleUserId: assignment.backgroundInformation?.responsibleUserId,
      responsibleTeamId: assignment.backgroundInformation?.responsibleTeamId,
      citizenMedicalDiagnoses: assignment.backgroundInformation?.citizenMedicalDiagnoses,
      citizenMedicalDiagnosesRichText: assignment.backgroundInformation?.citizenMedicalDiagnosesRichText,
      specialInformationAboutCitizen: assignment.backgroundInformation?.specialInformationAboutCitizen,
      specialInformationAboutCitizenRichText: assignment.backgroundInformation?.specialInformationAboutCitizenRichText,
      hasGuardian: assignment.backgroundInformation?.hasGuardian,
      guardianType: assignment.backgroundInformation?.guardianType,
      guardianDetails: assignment.backgroundInformation?.guardianDetails,
      isRepresented: assignment.backgroundInformation?.isRepresented,
      representationType: assignment.backgroundInformation?.representationType,
      powersOfAttorney: assignment.backgroundInformation?.powersOfAttorney,
    },
    coordinationDetails: {
      descriptionOfOtherInterventions: assignment.coordinationDetails?.descriptionOfOtherInterventions,
      descriptionOfOtherInterventionsRichText: assignment.coordinationDetails?.descriptionOfOtherInterventionsRichText,
      agreementsBetweenCitizenAndRelatives: assignment.coordinationDetails?.agreementsBetweenCitizenAndRelatives,
    },
    assessmentInformation: {
      primaryAssessmentTopicId: assignment.assessmentInformation?.primaryAssessmentTopicId,
      additionalAssessmentTopicIds: assignment.assessmentInformation?.additionalAssessmentTopicIds,
      assessmentSummary: assignment.assessmentInformation?.assessmentSummary,
      assessmentSummaryRichText: assignment.assessmentInformation?.assessmentSummaryRichText,
      citizenSupportNeedsAssessment: assignment.assessmentInformation?.citizenSupportNeedsAssessment,
      citizenSupportNeedsAssessmentRichText: assignment.assessmentInformation?.citizenSupportNeedsAssessmentRichText,
      citizenPerspectiveInfo: assignment.assessmentInformation?.citizenPerspectiveInfo,
      citizenPerspectiveInfoRichText: assignment.assessmentInformation?.citizenPerspectiveInfoRichText,
      citizenAssessmentResourceInfo: assignment.assessmentInformation?.citizenAssessmentResourceInfo,
      citizenAssessmentResourceInfoRichText: assignment.assessmentInformation?.citizenAssessmentResourceInfoRichText,
      challengesAndNeedsInfo: assignment.assessmentInformation?.challengesAndNeedsInfo,
      challengesAndNeedsInfoRichText: assignment.assessmentInformation?.challengesAndNeedsInfoRichText,
      citizenFutureAspirationsInfo: assignment.assessmentInformation?.citizenFutureAspirationsInfo,
      citizenFutureAspirationsInfoRichText: assignment.assessmentInformation?.citizenFutureAspirationsInfoRichText,
      citizenAssessmentPurposeInfo: assignment.assessmentInformation?.citizenAssessmentPurposeInfo,
      citizenAssessmentPurposeInfoRichText: assignment.assessmentInformation?.citizenAssessmentPurposeInfoRichText,
    },
    commissionedIntervention: {
      grantTypeId: assignment.commissionedIntervention?.grantTypeId ?? 'undefined',
      socialOfferFFBId: assignment.commissionedIntervention?.socialOfferFFBId,
      benefitTypeIds: assignment.commissionedIntervention?.benefitTypeIds,
      reportingFrequency: assignment.commissionedIntervention?.reportingFrequency,
      daysBetweenMeasurements: assignment.commissionedIntervention?.daysBetweenMeasurements,
      followUpDate: assignment.commissionedIntervention?.followUpDate,
      agreementsBetweenAuthorityAndProvider: assignment.commissionedIntervention?.agreementsBetweenAuthorityAndProvider,
    },
  };

  return {
    citizenId,
    activityId,
    assignment: assignmentPayload,
  };
}
